import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';

const TIMESTATEMENT_FETCH_REQUEST =
  'app/WorkerTimestatementDetailsPage/TIMESTATEMENT_FETCH_REQUEST';
const TIMESTATEMENT_FETCH_SUCCESS =
  'app/WorkerTimestatementDetailsPage/TIMESTATEMENT_FETCH_SUCCESS';
const TIMESTATEMENT_FETCH_ERROR = 'app/WorkerTimestatementDetailsPage/TIMESTATEMENT_FETCH_ERROR';

const TIMESTATEMENT_UPDATE_REQUEST =
  'app/WorkerTimestatementDetailsPage/TIMESTATEMENT_UPDATE_REQUEST';
const TIMESTATEMENT_UPDATE_SUCCESS =
  'app/WorkerTimestatementDetailsPage/TIMESTATEMENT_UPDATE_SUCCESS';
const TIMESTATEMENT_UPDATE_ERROR = 'app/WorkerTimestatementDetailsPage/TIMESTATEMENT_UPDATE_ERROR';

const initalState = {
  transactions: [],
  timeStatement: null,
  timeStatementsFetchInProgress: true,
  timeStatementsFetchError: null,
  timeStateUpdateInProgress: false,
  timeStatementUpdateError: null,
};

export default function WorkerTimestatementDetailsPageReducer(state = initalState, action = {}) {
  const { payload, type } = action || {};

  switch (type) {
    case TIMESTATEMENT_FETCH_REQUEST:
      return {
        ...state,
        timeStatementsFetchInProgress: true,
        transactions: [],
        timeStatement: null,
        timeStatementsFetchError: null,
      };
    case TIMESTATEMENT_FETCH_SUCCESS:
      return {
        ...state,
        timeStatementsFetchInProgress: false,
        transactions: payload.transactions,
        timeStatement: payload.timeStatement,
      };
    case TIMESTATEMENT_FETCH_ERROR:
      return {
        ...state,
        timeStatementsFetchInProgress: false,
        timeStatementsFetchError: payload,
      };
    case TIMESTATEMENT_UPDATE_REQUEST:
      return {
        ...state,
        timeStateUpdateInProgress: true,
        timeStatementUpdateError: null,
      };
    case TIMESTATEMENT_UPDATE_SUCCESS: {
      return {
        ...state,
        timeStateUpdateInProgress: false,
        timeStatement: payload,
      };
    }
    case TIMESTATEMENT_UPDATE_ERROR:
      return {
        ...state,
        timeStateUpdateInProgress: false,
        timeStatementUpdateError: payload,
      };
    default:
      return { ...state };
  }
}

//======================================== Action creator =====================================//

const timeStatementFetchRequest = () => ({ type: TIMESTATEMENT_FETCH_REQUEST });
const timeStatementFetchSuccess = payload => ({ type: TIMESTATEMENT_FETCH_SUCCESS, payload });
const timeStatementFetchFailure = payload => ({ type: TIMESTATEMENT_FETCH_ERROR, payload });

const timeStatementUpdateRequest = () => ({ type: TIMESTATEMENT_UPDATE_REQUEST });
const timeStatementUpdateSuccess = payload => ({ type: TIMESTATEMENT_UPDATE_SUCCESS, payload });
const timeStatementUpdateFailure = payload => ({ type: TIMESTATEMENT_UPDATE_ERROR, payload });

//===================================== Thunk ===================================//

const fetchUserTimeStatement = (workerId, gigId) => async (dispatch, getState, sdk) => {
  let transactions = [],
    page = 1,
    totalPages = 1;
  const query = {
    listingId: gigId,
    only: 'order',
    include: ['provider', 'customer', 'booking', 'listing'],
  };
  const { timeStatementsFetchInProgress } = getState().WorkerTimeStatementDetailsPage;
  try {
    if (!timeStatementsFetchInProgress) dispatch(timeStatementFetchRequest());
    for (; page <= totalPages; page++) {
      const resp = await sdk.transactions.query({ ...query, page });
      const entities = denormalisedResponseEntities(resp);
      transactions.push(...entities);
      totalPages = resp.data.meta.totalPages;
    }
    const timestatementUrl = `${apiBaseUrl()}/api/timeStatement/get?listingId=${gigId}&workerId=${workerId}&details=true`;
    const resp = await axios.get(timestatementUrl);
    const timeStatement = {
      ...resp.data[0],
      listing: transactions[0].listing,
      provider: transactions[0].provider,
      worker: transactions[0].customer,
    };
    dispatch(timeStatementFetchSuccess({ transactions, timeStatement }));
  } catch (e) {
    dispatch(timeStatementFetchFailure(storableError(e)));
  }
};

export const updateTimeStatement = (data, type) => (dispatch, getState, sdk) => {
  const { timeStateUpdateInProgress, timeStatement } = getState().WorkerTimeStatementDetailsPage;
  if (timeStateUpdateInProgress) return;
  dispatch(timeStatementUpdateRequest());
  const updateUrl = `${apiBaseUrl()}/api/timeStatement/updateAttendance/${type}`;
  return axios
    .patch(updateUrl, data)
    .then(response => {
      const newTimeStatement = { ...timeStatement, ...response.data };
      dispatch(timeStatementUpdateSuccess(newTimeStatement));
      return response.data;
    })
    .catch(error => {
      const strErr = storableError(error);
      if (typeof error.response?.data === 'object') {
        strErr.customMessage = error.response.data;
      }
      dispatch(timeStatementUpdateFailure(strErr));
      throw error;
    });
};

export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  const { gigId } = params;
  dispatch(timeStatementFetchRequest());
  return dispatch(fetchCurrentUser()).then(() => {
    const { currentUser } = getState().user;
    return dispatch(fetchUserTimeStatement(currentUser.id.uuid, gigId));
  });
};
